import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { SharePageService } from '../share-page-service';
import { type ApiPageInitResponse, PageInit } from '@/infrastructure/api-functions/core-drafting-api/page-init-api';
import { PublicShareApi } from '@telecom/shared/infrastructure/api-functions/public-share-api';
import { ShareModel } from '@telecom/shared/domain/permission/models/share-model';

@injectable()
export class SharePageServiceImpl implements SharePageService {
    _taskId: string = '';
    constructor(
        @inject(PageInit)
        private readonly _pageInit: PageInit,
        @inject(PublicShareApi)
        private readonly _publicShareApi: PublicShareApi,
        @inject(ShareModel)
        private readonly _shareModel: ShareModel,
    ) {}

    get taskId(): string {
        return this._taskId;
    }

    get shareId(): string {
        return this.getPageQueryValue('shareId') || '';
    }

    get isSharePage(): boolean {
        return !this._shareModel.modelData.isShareModel && !!this.shareId;
    }

    async initialize(): Promise<void> {
        if (!this.shareId) {
            return;
        }
        if (this._taskId) {
            return;
        }
        this._taskId = await this._publicShareApi.getShareInit({
            share_id: this.shareId,
        }).then(res=> res.task_id);

    }

    // eslint-disable-next-line max-lines-per-function
    public pageInitProxy(): Promise<ApiPageInitResponse> {
        if(this.isSharePage){
            console.warn('PageInitServiceImpl: getPageInitData: share page, return default data');
            return Promise.resolve({
                permission: {
                    ai_disclosure: true,
                    ai_translation: true,
                    ai_specification_cn: true,
                    ai_specification_us: true,
                    ai_specification_eu: true,
                    ai_novelty_search: true,
                    ai_fto_search: true,
                },
                novelty_search_usage:{
                    usage: 0,
                    total: 0,
                },
                fto_search_usage: {
                    usage: 0,
                    total: 0,
                },
                specification_usage: {
                    usage: 0,
                    total: 0,
                },
                patent_disclosure_usage: {
                    usage: 0,
                    total: 0,
                },
                translation_usage: {
                    usage: 0,
                    total: 0,
                },
                cn_patent_specification_usage: {
                    usage: 0,
                    total: 0,
                },
                us_patent_specification_usage: {
                    usage: 0,
                    total: 0,
                },
                eu_patent_specification_usage: {
                    usage: 0,
                    total: 0,
                },
                unified_patent_specification_usage: {
                    usage: 0,
                    total: 0,
                },
                unified_usage: {
                    usage: 0,
                    total: 0,
                },
                unified_pro_usage: {
                    usage: 0,
                    total: 0,
                },
                unified_free_usage: {
                    usage: 0,
                    total: 0,
                },
                time_zone: {
                    utc_offset: 0,
                    value: 'UTC',
                },
                tier_code: 'FREE',
            });
        }
        return this._pageInit.pageInit();
    }

    private getPageQueryValue(key: string): string | null {
        const url = new URL(window.location.href);
        const value = url.searchParams.get(key);
        if (value) {
            return value;
        }
        if (!window.location.hash) {
            return null;
        }
        const hashUrl = new URL(window.location.origin + window.location.hash.replace('#', ''));
        const hashValue = hashUrl.searchParams.get(key);
        return hashValue;
    }
}
